module.exports = __webpack_public_path__ + "assets/retina_TrapezoidGeomMeanDetailed.ebd473828f366a10e22e2731f78aa080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrapezoidGeomMeanDetailed.png
// module id = 747
// module chunks = 0